/* tslint:disable */
/* eslint-disable */
/**
 * OnData.Metrics
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface DatabaseMetricsInput
 */
export interface DatabaseMetricsInput {
    /**
     * 
     * @type {number}
     * @memberof DatabaseMetricsInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {InstanceStatus}
     * @memberof DatabaseMetricsInput
     */
    'status'?: InstanceStatus;
    /**
     * 
     * @type {number}
     * @memberof DatabaseMetricsInput
     */
    'connectionCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseMetricsInput
     */
    'maxQueryTime'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DatabaseMetricsInput
     */
    'avgQueryTime'?: number | null;
}
/**
 * 
 * @export
 * @interface DatabaseSizeMetricsInput
 */
export interface DatabaseSizeMetricsInput {
    /**
     * 
     * @type {number}
     * @memberof DatabaseSizeMetricsInput
     */
    'databaseId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseSizeMetricsInput
     */
    'backupId'?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabaseSizeMetricsInput
     */
    'databaseSize'?: number;
    /**
     * 
     * @type {Array<TableMetricsInput>}
     * @memberof DatabaseSizeMetricsInput
     */
    'tableMetrics'?: Array<TableMetricsInput> | null;
    /**
     * 
     * @type {Array<IndexMetricsInput>}
     * @memberof DatabaseSizeMetricsInput
     */
    'indexMetrics'?: Array<IndexMetricsInput> | null;
}
/**
 * 
 * @export
 * @interface IndexMetricsInput
 */
export interface IndexMetricsInput {
    /**
     * 
     * @type {string}
     * @memberof IndexMetricsInput
     */
    'schema': string;
    /**
     * 
     * @type {string}
     * @memberof IndexMetricsInput
     */
    'tableName': string;
    /**
     * 
     * @type {string}
     * @memberof IndexMetricsInput
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof IndexMetricsInput
     */
    'size'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum InstanceStatus {
    Offline = 0,
    Online = 1
}

/**
 * 
 * @export
 * @interface LineChartData
 */
export interface LineChartData {
    /**
     * 
     * @type {string}
     * @memberof LineChartData
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof LineChartData
     */
    'data'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface LineChartDataWithPairs
 */
export interface LineChartDataWithPairs {
    /**
     * 
     * @type {string}
     * @memberof LineChartDataWithPairs
     */
    'name'?: string | null;
    /**
     * 
     * @type {Array<Array<any>>}
     * @memberof LineChartDataWithPairs
     */
    'data'?: Array<Array<any>> | null;
}
/**
 * 
 * @export
 * @interface LineChartResponseDto
 */
export interface LineChartResponseDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof LineChartResponseDto
     */
    'legend'?: Array<string> | null;
    /**
     * 
     * @type {Array<LineChartData>}
     * @memberof LineChartResponseDto
     */
    'series'?: Array<LineChartData> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof LineChartResponseDto
     */
    'xaxis'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface LineChartWithPairsResponseDto
 */
export interface LineChartWithPairsResponseDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof LineChartWithPairsResponseDto
     */
    'legend'?: Array<string> | null;
    /**
     * 
     * @type {Array<LineChartDataWithPairs>}
     * @memberof LineChartWithPairsResponseDto
     */
    'series'?: Array<LineChartDataWithPairs> | null;
}
/**
 * 
 * @export
 * @interface TableMetricsInput
 */
export interface TableMetricsInput {
    /**
     * 
     * @type {string}
     * @memberof TableMetricsInput
     */
    'schema': string;
    /**
     * 
     * @type {string}
     * @memberof TableMetricsInput
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof TableMetricsInput
     */
    'size'?: number;
    /**
     * 
     * @type {number}
     * @memberof TableMetricsInput
     */
    'rowCount'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum TimeRangeType {
    Week = 0,
    Month = 1,
    Year = 2,
    Hour = 3,
    Day = 4
}


/**
 * MetricsApi - axios parameter creator
 * @export
 */
export const MetricsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMetricsLinechartAvgquerytimeGet: async (timeRangeType?: TimeRangeType, endTime?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/metrics/linechart/avgquerytime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (timeRangeType !== undefined) {
                localVarQueryParameter['timeRangeType'] = timeRangeType;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMetricsLinechartDbsizeGet: async (databaseId?: number, timeRangeType?: TimeRangeType, endTime?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/metrics/linechart/dbsize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }

            if (timeRangeType !== undefined) {
                localVarQueryParameter['timeRangeType'] = timeRangeType;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMetricsLinechartIndexsizeGet: async (databaseId?: number, timeRangeType?: TimeRangeType, endTime?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/metrics/linechart/indexsize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }

            if (timeRangeType !== undefined) {
                localVarQueryParameter['timeRangeType'] = timeRangeType;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMetricsLinechartMaxquerytimeGet: async (timeRangeType?: TimeRangeType, endTime?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/metrics/linechart/maxquerytime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (timeRangeType !== undefined) {
                localVarQueryParameter['timeRangeType'] = timeRangeType;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMetricsLinechartRowcountGet: async (databaseId?: number, timeRangeType?: TimeRangeType, endTime?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/metrics/linechart/rowcount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (databaseId !== undefined) {
                localVarQueryParameter['databaseId'] = databaseId;
            }

            if (timeRangeType !== undefined) {
                localVarQueryParameter['timeRangeType'] = timeRangeType;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [deploymentId] 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMetricsLinechartVmavailablememoryGet: async (deploymentId?: number, timeRangeType?: TimeRangeType, endTime?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/metrics/linechart/vmavailablememory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deploymentId !== undefined) {
                localVarQueryParameter['deploymentId'] = deploymentId;
            }

            if (timeRangeType !== undefined) {
                localVarQueryParameter['timeRangeType'] = timeRangeType;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [deploymentId] 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMetricsLinechartVmcpuGet: async (deploymentId?: number, timeRangeType?: TimeRangeType, endTime?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/metrics/linechart/vmcpu`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deploymentId !== undefined) {
                localVarQueryParameter['deploymentId'] = deploymentId;
            }

            if (timeRangeType !== undefined) {
                localVarQueryParameter['timeRangeType'] = timeRangeType;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [deploymentId] 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMetricsLinechartVmdiskGet: async (deploymentId?: number, timeRangeType?: TimeRangeType, endTime?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/metrics/linechart/vmdisk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (deploymentId !== undefined) {
                localVarQueryParameter['deploymentId'] = deploymentId;
            }

            if (timeRangeType !== undefined) {
                localVarQueryParameter['timeRangeType'] = timeRangeType;
            }

            if (endTime !== undefined) {
                localVarQueryParameter['endTime'] = (endTime as any instanceof Date) ?
                    (endTime as any).toISOString() :
                    endTime;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetricsApi - functional programming interface
 * @export
 */
export const MetricsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetricsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMetricsLinechartAvgquerytimeGet(timeRangeType?: TimeRangeType, endTime?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LineChartWithPairsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMetricsLinechartAvgquerytimeGet(timeRangeType, endTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMetricsLinechartDbsizeGet(databaseId?: number, timeRangeType?: TimeRangeType, endTime?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LineChartResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMetricsLinechartDbsizeGet(databaseId, timeRangeType, endTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMetricsLinechartIndexsizeGet(databaseId?: number, timeRangeType?: TimeRangeType, endTime?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LineChartResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMetricsLinechartIndexsizeGet(databaseId, timeRangeType, endTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMetricsLinechartMaxquerytimeGet(timeRangeType?: TimeRangeType, endTime?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LineChartWithPairsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMetricsLinechartMaxquerytimeGet(timeRangeType, endTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMetricsLinechartRowcountGet(databaseId?: number, timeRangeType?: TimeRangeType, endTime?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LineChartResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMetricsLinechartRowcountGet(databaseId, timeRangeType, endTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [deploymentId] 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMetricsLinechartVmavailablememoryGet(deploymentId?: number, timeRangeType?: TimeRangeType, endTime?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LineChartWithPairsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMetricsLinechartVmavailablememoryGet(deploymentId, timeRangeType, endTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [deploymentId] 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMetricsLinechartVmcpuGet(deploymentId?: number, timeRangeType?: TimeRangeType, endTime?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LineChartWithPairsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMetricsLinechartVmcpuGet(deploymentId, timeRangeType, endTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [deploymentId] 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMetricsLinechartVmdiskGet(deploymentId?: number, timeRangeType?: TimeRangeType, endTime?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LineChartWithPairsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMetricsLinechartVmdiskGet(deploymentId, timeRangeType, endTime, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MetricsApi - factory interface
 * @export
 */
export const MetricsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetricsApiFp(configuration)
    return {
        /**
         * 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMetricsLinechartAvgquerytimeGet(timeRangeType?: TimeRangeType, endTime?: string, options?: any): AxiosPromise<LineChartWithPairsResponseDto> {
            return localVarFp.apiMetricsLinechartAvgquerytimeGet(timeRangeType, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMetricsLinechartDbsizeGet(databaseId?: number, timeRangeType?: TimeRangeType, endTime?: string, options?: any): AxiosPromise<LineChartResponseDto> {
            return localVarFp.apiMetricsLinechartDbsizeGet(databaseId, timeRangeType, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMetricsLinechartIndexsizeGet(databaseId?: number, timeRangeType?: TimeRangeType, endTime?: string, options?: any): AxiosPromise<LineChartResponseDto> {
            return localVarFp.apiMetricsLinechartIndexsizeGet(databaseId, timeRangeType, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMetricsLinechartMaxquerytimeGet(timeRangeType?: TimeRangeType, endTime?: string, options?: any): AxiosPromise<LineChartWithPairsResponseDto> {
            return localVarFp.apiMetricsLinechartMaxquerytimeGet(timeRangeType, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [databaseId] 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMetricsLinechartRowcountGet(databaseId?: number, timeRangeType?: TimeRangeType, endTime?: string, options?: any): AxiosPromise<LineChartResponseDto> {
            return localVarFp.apiMetricsLinechartRowcountGet(databaseId, timeRangeType, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [deploymentId] 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMetricsLinechartVmavailablememoryGet(deploymentId?: number, timeRangeType?: TimeRangeType, endTime?: string, options?: any): AxiosPromise<LineChartWithPairsResponseDto> {
            return localVarFp.apiMetricsLinechartVmavailablememoryGet(deploymentId, timeRangeType, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [deploymentId] 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMetricsLinechartVmcpuGet(deploymentId?: number, timeRangeType?: TimeRangeType, endTime?: string, options?: any): AxiosPromise<LineChartWithPairsResponseDto> {
            return localVarFp.apiMetricsLinechartVmcpuGet(deploymentId, timeRangeType, endTime, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [deploymentId] 
         * @param {TimeRangeType} [timeRangeType] 
         * @param {string} [endTime] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMetricsLinechartVmdiskGet(deploymentId?: number, timeRangeType?: TimeRangeType, endTime?: string, options?: any): AxiosPromise<LineChartWithPairsResponseDto> {
            return localVarFp.apiMetricsLinechartVmdiskGet(deploymentId, timeRangeType, endTime, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MetricsApi - object-oriented interface
 * @export
 * @class MetricsApi
 * @extends {BaseAPI}
 */
export class MetricsApi extends BaseAPI {
    /**
     * 
     * @param {TimeRangeType} [timeRangeType] 
     * @param {string} [endTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public apiMetricsLinechartAvgquerytimeGet(timeRangeType?: TimeRangeType, endTime?: string, options?: AxiosRequestConfig) {
        return MetricsApiFp(this.configuration).apiMetricsLinechartAvgquerytimeGet(timeRangeType, endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {TimeRangeType} [timeRangeType] 
     * @param {string} [endTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public apiMetricsLinechartDbsizeGet(databaseId?: number, timeRangeType?: TimeRangeType, endTime?: string, options?: AxiosRequestConfig) {
        return MetricsApiFp(this.configuration).apiMetricsLinechartDbsizeGet(databaseId, timeRangeType, endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {TimeRangeType} [timeRangeType] 
     * @param {string} [endTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public apiMetricsLinechartIndexsizeGet(databaseId?: number, timeRangeType?: TimeRangeType, endTime?: string, options?: AxiosRequestConfig) {
        return MetricsApiFp(this.configuration).apiMetricsLinechartIndexsizeGet(databaseId, timeRangeType, endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {TimeRangeType} [timeRangeType] 
     * @param {string} [endTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public apiMetricsLinechartMaxquerytimeGet(timeRangeType?: TimeRangeType, endTime?: string, options?: AxiosRequestConfig) {
        return MetricsApiFp(this.configuration).apiMetricsLinechartMaxquerytimeGet(timeRangeType, endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [databaseId] 
     * @param {TimeRangeType} [timeRangeType] 
     * @param {string} [endTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public apiMetricsLinechartRowcountGet(databaseId?: number, timeRangeType?: TimeRangeType, endTime?: string, options?: AxiosRequestConfig) {
        return MetricsApiFp(this.configuration).apiMetricsLinechartRowcountGet(databaseId, timeRangeType, endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [deploymentId] 
     * @param {TimeRangeType} [timeRangeType] 
     * @param {string} [endTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public apiMetricsLinechartVmavailablememoryGet(deploymentId?: number, timeRangeType?: TimeRangeType, endTime?: string, options?: AxiosRequestConfig) {
        return MetricsApiFp(this.configuration).apiMetricsLinechartVmavailablememoryGet(deploymentId, timeRangeType, endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [deploymentId] 
     * @param {TimeRangeType} [timeRangeType] 
     * @param {string} [endTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public apiMetricsLinechartVmcpuGet(deploymentId?: number, timeRangeType?: TimeRangeType, endTime?: string, options?: AxiosRequestConfig) {
        return MetricsApiFp(this.configuration).apiMetricsLinechartVmcpuGet(deploymentId, timeRangeType, endTime, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [deploymentId] 
     * @param {TimeRangeType} [timeRangeType] 
     * @param {string} [endTime] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetricsApi
     */
    public apiMetricsLinechartVmdiskGet(deploymentId?: number, timeRangeType?: TimeRangeType, endTime?: string, options?: AxiosRequestConfig) {
        return MetricsApiFp(this.configuration).apiMetricsLinechartVmdiskGet(deploymentId, timeRangeType, endTime, options).then((request) => request(this.axios, this.basePath));
    }
}


